import { SiteMeta } from '@src/types/SiteMeta';
import storeConnector from '@store/storeConnector';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  styled,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { CommandsCategory } from '@src/types/Commands';
import { MqttClient } from 'mqtt';
import { memo } from 'react';
import { CommandsModalContextProvider } from '../CommandsModalContext';
import useAlias from '@src/hooks/useAlias';
import PowerSection from './PowerSection';
import usePowinControllerPowerData from './hooks/usePowinControllerPowerData';

const StyledDialogTitle = styled(DialogTitle)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

interface Props {
  mqttClient: MqttClient;
  deviceId: string;
  deviceName: string;
  onClose: () => void;
  siteMeta: SiteMeta;
}

const PowinControllerCommandsModal: React.FC<Props> = ({
  mqttClient,
  deviceId,
  deviceName,
  onClose,
  siteMeta,
}) => {
  const alias = useAlias();
  const powerData = usePowinControllerPowerData(mqttClient, siteMeta, deviceId);

  return (
    <CommandsModalContextProvider
      category={CommandsCategory.POWINEMS}
      deviceId={siteMeta.siteId}
    >
      <Dialog open onClose={onClose} maxWidth='sm' fullWidth>
        <StyledDialogTitle>
          {deviceName} {alias('Commands')}
          <IconButton onClick={onClose} sx={{ mr: -2, mt: -1 }}>
            <CloseIcon />
          </IconButton>
        </StyledDialogTitle>
        <DialogContent dividers>
          <PowerSection
            currentPset={powerData.currentPset}
            currentQset={powerData.currentQset}
            minPThreshold={powerData.minPThreshold}
            maxPThreshold={powerData.maxPThreshold}
            minQThreshold={powerData.minQThreshold}
            maxQThreshold={powerData.maxQThreshold}
          />
        </DialogContent>
      </Dialog>
    </CommandsModalContextProvider>
  );
};

PowinControllerCommandsModal.displayName = 'PowinControllerCommandsModal';

export default storeConnector(memo(PowinControllerCommandsModal), {
  config: ['siteMeta'],
  user: ['role'],
});
